<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [regex]="regex" [commas]="commas" [label]="label" />
